// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const Wrapper = styled.div`
  background: #0d0d0d;
  color: #fff;
  display: flex;
  font-size: .85rem;
  padding: .5em 1em;

  > a,
  > a:hover {
    color: inherit;
  }

  > span {
    > a, > a:hover {
      color: #1EAFEC;
    }
  }
`
export const Contacts = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`
